import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import Link from 'next/link';
import type { ReactNode } from 'react';
import Card, { type CardPadding } from '../Card';
import styles from './StatCard.module.scss';
export type StatCardStatSize = 'md' | 'lg';
export interface StatCardCta {
  label: string;
  href: string;
}
export interface StatCardProps {
  stat: string;
  /** Phrasing content: it renders inside the card's `<p>`, so a footnote
   * marker (`<sup>`) or an inline link can stay in the copy (Phase 5 PR 5.2). */
  description: ReactNode;
  cta?: StatCardCta;
  /** Optional fine-print rendered below the description (e.g. a data source). */
  footnote?: ReactNode;
  /** Stat number size on the card title's display tuple (600, tight).
   * `'md'` (default, 24px) for compact homepage grids; `'lg'` (40px) for
   * marketing proof points. */
  statSize?: StatCardStatSize;
  fullHeight?: boolean;
  /** Forwarded to the underlying Card. Defaults to `'none'`: StatCard draws
   * no box (Phase 4 PR 4), so the stat starts on its column's text edge. */
  padded?: CardPadding;
  mobilePadded?: CardPadding;
}
function StatCard(t0) {
  const $ = _c(19);
  const {
    stat,
    description,
    cta,
    footnote,
    statSize: t1,
    fullHeight,
    padded: t2,
    mobilePadded: t3
  } = t0;
  const statSize = t1 === undefined ? "md" : t1;
  const padded = t2 === undefined ? "none" : t2;
  const mobilePadded = t3 === undefined ? "none" : t3;
  const t4 = styles[`helios-stat-card__stat--${statSize}`];
  let t5;
  if ($[0] !== t4) {
    t5 = classNames(styles["helios-stat-card__stat"], t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== stat || $[3] !== t5) {
    t6 = <h3 className={t5}>{stat}</h3>;
    $[2] = stat;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== description) {
    t7 = <p className={styles["helios-stat-card__desc"]}>{description}</p>;
    $[5] = description;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== footnote) {
    t8 = footnote && <p className={styles["helios-stat-card__footnote"]}><small>{footnote}</small></p>;
    $[7] = footnote;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== cta) {
    t9 = cta && <Link href={cta.href} className={styles["helios-stat-card__cta"]}>{cta.label}</Link>;
    $[9] = cta;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== fullHeight || $[12] !== mobilePadded || $[13] !== padded || $[14] !== t6 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <Card fullHeight={fullHeight} padded={padded} mobilePadded={mobilePadded} className={styles["helios-stat-card"]}>{t6}{t7}{t8}{t9}</Card>;
    $[11] = fullHeight;
    $[12] = mobilePadded;
    $[13] = padded;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
export default StatCard;